<template>
	<!--Menu-->
	<div class="page-menu menu">
		<div class="user-info">
			<div class="user-pic-cont">
				<div class="user-pic fx-align b-r-50" >
					<img :src="userInfo.logo_url || logo" />
				</div>
				<div class="logo-top" @click="handleLink"></div>
			</div>
			<div class="fx fx-x-between fx-y-center">
				<p class="user-name" @click="handleLink">{{userInfo.username || userInfo.phone}}</p>
				<!--<div class="triangle">
					<ol>
						<router-link :class="{'active':active =='index'}" :to="{ name: 'users',query:{type:'userCenter'}}" tag="li">商户信息</router-link>
						<router-link :class="{'active':active =='index'}" :to="{ name: 'users',query:{type:'modifPwd'}}" tag="li">修改密码</router-link>
						<li @click="handleOutLogin">退出登录</li>
					</ol>
				</div>-->
			</div>
		</div>
		<nav>
			<ul>
				<router-link :class="{'active':active =='index'}" :to="{ name: 'index'}" tag="li"><i class="icon-index"></i>首页</router-link>
				<router-link :class="{'active':active =='shops'}" :to="{ name: 'shopsManage'}" tag="li"><i class="icon-shop"></i>门店管理</router-link>
				<router-link :class="{'active':active =='pay'}" :to="{ name: 'payCount'}" tag="li"><i class="icon-payment"></i>收银管理</router-link>
				<router-link :class="{'active':active =='wechat'}" :to="{ name: 'wxIndex'}" tag="li"><i class="icon-wechet"></i>公众号管理</router-link>
				<router-link :class="{'active':active =='vmall'}" :to="{ name: 'statistics'}" tag="li"><i class="icon-vmall"></i>微商城管理</router-link>
				<router-link :class="{'active':active =='vip'}" :to="{ name: 'vipManage'}" tag="li"><i class="icon-vipcard"></i>会员卡管理</router-link>
				<router-link :class="{'active':active =='marketing'}" :to="{ name: 'marketing'}" tag="li"><i class="icon-admin"></i>营销工具</router-link>
				<router-link :class="{'active':active =='finance'}" :to="{ name: 'financeList'}" tag="li"><i class="icon-report-form"></i>财务报表</router-link>
				<router-link :class="{'active':active =='users'}" :to="{ name: 'users',query:{type:'userCenter'}}" tag="li"><i class="icon-merchant"></i>商户中心</router-link>
				<router-link :class="{'active':active =='clear'}" :to="{ name: 'clearList'}" tag="li"><i class="icon-settlement"></i>结算记录</router-link>
			</ul>
		</nav>
		<!--<div class="support">
			<p>联系客服</p>
			<p>QQ：877200772</p>
		</div>-->
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	import logo from '@/assets/img/logo.png'
	export default {
		name: "z-menu",
		/*
		 * 接收父组件数据
		 */
		data() {
			return {
				active: '',
				logo: logo
			}
		},
		mounted() {
	   	 	this.handleActive()
		},
		watch: {
			$route() {
				this.handleActive()
			}
		},
		/*
		 * 实例计算属性
		 */
		computed: {
			...mapState({
				userInfo: state => state.users.userInfo
			})
		},
		/*
		 * 处理事件
		 */
		methods: {
//			async handleOutLogin() { //退出登录
//				try {
//					await this.$confirm(`确定要退出?`)
//					await this.outLogin()
//					this.$router.replace({
//						name: 'login'
//					})
//				} catch(e) {
//					this.$log(e)
//				}
//			},
			handleLink(){
				this.$router.replace({
					name: 'users'
				})
			},
			handleActive() {
//				this.$log('=========>',this.$route.meta.active)
				this.active = this.$route.meta.active
			},
			handleSwitch() {
				this.switchOff = this.switchOff ? false : true
			},
			...mapActions(['outLogin'])
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.menu {
		width: 100%;
		height: 100%;
		background: $color-black;
		color: $color-font-sub;
		position: relative;
		box-shadow: -4px 0 6px rgba(0, 0, 0, 0.2) inset;
		.user-info {
			position: relative;
			padding: px-em(40px);
			border-bottom: 1px solid $color-dark-border;
			margin-bottom: px-em(20px);
			.triangle {
				position: relative;
				margin-top: px-em(40px);
				padding: px-em(20px);
				cursor: pointer;
				&:hover {
					ol {
						opacity: 1;
						visibility: visible;
					}
				}
				&:after {
					content: "";
					position: absolute;
					top: px-em(10px);
					left: px-em(8px);
					width: 0;
					height: 0;
					border-left: 6px solid transparent;
					border-right: 6px solid transparent;
					border-top: 10px solid $color-font-sub;
				}
				ol {
					opacity: 0;
					visibility: hidden;
					position: absolute;
					right: px-em(-20px);
					top: px-em(40px);
					background: $color-white;
					border: 1px solid $color-border;
					padding: px-em(20px) 0;
					z-index: 9;
					transition: all 0.2s ease;
					border-radius: 2px;
					li {
						width: px-em(200px);
						text-align: center;
						padding: px-em(10px) 0;
						color: $color-font;
						transition: all 0.2s ease;
						cursor: pointer;
						&:hover {
							color: $color-main;
						}
					}
				}
			}
			.user-name {
				cursor: pointer;
				color: $color-font-sub;
				padding-top: px-em(40px);
			}
			.user-pic-cont {
				position: relative;
				width: px-em(112px);
				height: px-em(112px);
				overflow: hidden;
				.user-pic {
					border: 2px solid $color-dark-border;
					width: px-em(112px);
					height: px-em(112px);
					overflow: hidden;
					background-size: 100%;
					position: relative;
					font-size: 40px;
					img {
						width: 100%;
						height: 100%;
					}
				}
				.logo-top {
					cursor: pointer;
					width: 100%;
					height: 100%;
					background: url(../../assets/img/top_border.png) center center no-repeat;
					background-size: px-em(148px);
					position: absolute;
					top: -0px;
					left: -0px;
					z-index: 99;
				}
				.hover {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: url(../../assets/img/top_boder_hover.png) center center no-repeat;
					background-size: px-em(148px) px-em(148px);
					-webkit-animation: user-pic-anim-name 3.5s linear infinite;
				}
				@-webkit-keyframes user-pic-anim-name {
					0% {
						-webkit-transform: rotate(0deg)
					}
					100% {
						-webkit-transform: rotate(360deg)
					}
				}
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		nav ul li {
			height: px-em(80px);
			line-height: px-em(80px);
			position: relative;
			cursor: pointer;
			transition: all 0.2s ease;
			-webkit-transition: all 0.2s ease;
			i {
				display: inline-block;
				width: px-em(160px);
				height: 100%;
				padding-left: px-em(40px);
				line-height: px-em(80px);
				font-size: px-em(36px);
				transition: all 0.2s ease;
				-webkit-transition: all 0.2s ease;
			}
			&.active,
			&.router-link-active,
			&:hover {
				color: $color-white;
				box-shadow: -4px 0 6px rgba(0, 0, 0, 0.2) inset;
				background: $color-main;
				.icon {
					color: $color-white;
				}
			}
		}
		.support {
			width: 100%;
			position: absolute;
			bottom: 0;
			left: 0;
			text-align: center;
			padding-bottom: px-em(20px);
			color: $color-7a7a7a;
		}
		.menu-btn {
			position: absolute;
			right: 0;
			top: 0;
			.switch {
				padding: px-em(10px) px-em(20px) px-em(12px);
				color: $color-main;
				cursor: pointer;
				font-size: 18px;
			}
		}
	}
	
	@media only screen and (min-width:0px) and (max-width:640px) {
		nav ul li i {
			width: px-em(90px) !important;
			padding-left: px-em(20px) !important;
		}
	}
</style>


// WEBPACK FOOTER //
// Menu.vue?7f768d6b